import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
	selector: 'app-unlink-transport-confirm-dialog',
	standalone: true,
	imports: [MatButton, MatDialogActions, MatDialogContent, MatDialogTitle],
	template: `<h2 mat-dialog-title>Rozłącz transporty</h2>
		<mat-dialog-content>Czy na pewno chcesz rozłączyć transporty?</mat-dialog-content>
		<mat-dialog-actions align="end">
			<button mat-raised-button color="warn" (click)="onCancel()">Nie</button>
			<button mat-raised-button color="primary" (click)="onConfirm()">Tak</button>
		</mat-dialog-actions>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnlinkTransportConfirmDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<UnlinkTransportConfirmDialogComponent, boolean>);

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}
}
